import './searchfield.jquery';

/**
 * jQuery Component Wrapper for Toolbar Searchfield
 * @param {object} [settings] incoming settings
 * @returns {jQuery[]} elements being acted on
 */
$.fn.toolbarsearchfield = $.fn.searchfield;
